import { say } from './text';

// How long, on the one ladder (Fire::Ago, docs/DESIGN.md § Time, one ladder):
// the same rungs, rounded half up, from the same `fire.ago` words the page carries.
//
//   words(2874 * 60)        → "2 dias"
//   words(2874 * 60, true)  → "há 2 dias"
//
// A rung ends half a unit short of its limit, where its rounding would reach
// the next unit (59.5 min is "1 h", never "60 min").
//
// [ends below (seconds), unit, seconds per unit]
const RUNGS = [
  [60, 'now', 1],
  [3600, 'min', 60],
  [86400, 'hour', 3600],
  [30 * 86400, 'day', 86400],
  [365 * 86400, 'month', 30 * 86400],
  [Infinity, 'year', 365 * 86400],
];

export function words(seconds, since = false) {
  const ago = say('ago');
  const whole = Math.max(Math.round(seconds), 0);
  const [, unit, size] = RUNGS.find(([limit, , step]) => whole < limit - step / 2);
  if (unit === 'now') return since ? ago.now : ago.under;

  const count = Math.floor((whole + size / 2) / size);
  const form = ago[unit];
  const text = (
    typeof form === 'string'
      ? form
      : (form[new Intl.PluralRules(document.documentElement.lang).select(count)] ?? form.other)
  ).replace('%{count}', count);
  return since ? ago.since.replace('%{time}', text) : text;
}
